import { render, staticRenderFns } from "./FormControlLg.vue?vue&type=template&id=286e3791"
import script from "./FormControlLg.vue?vue&type=script&lang=js"
export * from "./FormControlLg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports